<!-- 日志查询 -->
<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: WUFAN
 * @Date: 2020-04-21
 * @LastEditors: WUFAN
 * @LastEditTime: 2020-04-21
 -->
<!--  -->
<template>
  <div>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      v-model="form"
      ref="crud"
      @search-change="searchChange"
      @search-reset="searchReset"
      @current-change="currentChange"
      @size-change="sizeChange"
      @sort-change="sortChange"
      @on-load="onLoad"
      @refresh-change="refresh"
    >
      <!-- 状态栏目扩展  -->
      <template slot-scope="{type,size,row}" slot="menu">

        <el-button v-if="row.modifyType === 2" :type="type" :size="size" @click="VIEW(row)">详情</el-button>
      </template>
    </avue-crud>

  </div>
</template>

<script>
export default {
  props: ['option'],
  name: 'BlackAndWhiteListManage',
  data() {
    return {
      modifyDetails: {
        show: false,
        tableData: []
      },
      form: {},
      order: {},
      query: {},
      loading: true,
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 0
      },
      data: []

    }
  },

  components: {},

  mounted() {

  },
  methods: {

    refresh: function() {
      this.onLoad()
    },
    sortChange(value) {
      this.order.prop = value.prop
      this.order.order = value.order
      this.onLoad()
    },
    searchReset() {
      this.query = {}
      this.page.currentPage = 1
      this.onLoad()
    },
    searchChange(params, done) {
      for (let key in params) {
        if (params[key] === '') {
          delete params[key]
        }
      }
      done()
      this.page.currentPage = 1
      this.query = params
      this.onLoad()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    onLoad(page = this.page, params = this.query, order = this.order) {
      let orderItemList = []
      if (order.order) {
        orderItemList.push({
          asc: order.order === 'ascending',
          column: order.prop
        })
      } else {
        orderItemList.push({
          asc: false,
          column: 'auditTime'
        })
      }
      this.loading = true
      var that = this

      this.$http.post('/login-audit/query/self', { 'entity': params, 'orderItemList': orderItemList }, { params: {
        // startTime: this.query.startTime,
        // endTime: this.query.endTime,
        pageNum: page.currentPage,
        pageSize: page.pageSize
      }}).then(
        response => {
          that.loading = false
          var dataList = []
          var dicData = that.option.column[3].dicData
          response.data.records.forEach(element => {
            element.result = element.loginCode === 200 ? '成功' : '失败'
            dicData.forEach(item => {
              if (item.value === element.loginCode) {
                element.reason = item.label
              }
            })
            element.reason = element.reason ? element.reason : '失败'
            dataList.push(element)
          })
          that.data = dataList
          that.page.total = response.data.total || response.data.records.length
        }
      ).catch(
        error => {
          that.loading = false
          that.$message.error(error.msg)
        }
      )
    },
    VIEW(row) {
      try {
        this.modifyDetails.tableData = []
        let modifyFieds = row.modifyAttr.split(',')
        let originEntity = JSON.parse(row.originEntity) || {}
        let newEntity = JSON.parse(row.newEntity) || {}
        modifyFieds.forEach(item => {
          if (item && item !== 'userPassword') {
            this.modifyDetails.tableData.push({
              prop: item,
              oldVal: originEntity[item],
              newVal: newEntity[item]
            })
          }
        })
        if (this.modifyDetails.tableData.length) {
          this.modifyDetails.show = true
        } else {
          this.$message.error('该条记录可能为修改密码,无详情')
        }
      } catch (e) {
        this.$message.error('日志记录不完整,无法查看详情')
      }
    }

  }
}
</script>
<style lang='scss' scoped>
</style>

